module.exports = __webpack_public_path__ + "img/6231044.png";